import { type ReactElement } from 'react';
import { Outlet } from 'react-router';

export function PublicLayout(): ReactElement {
  return (
    <main className="flex min-h-screen flex-col bg-surface text-surface-fg">
      <Outlet />
    </main>
  );
}
